import * as types from "@/store/types";
import axios from "axios";

const ENV_IS_PRODUCTION = () => {
  return window.location.hostname.match(/(local|^(127|192)\.(0|168)\.0\.1|staging)/) === null
}

const STAGING_BASE_API_URL = `https://buscameaqui-staging-api.herokuapp.com`;
//const STAGING_BASE_API_URL = `http://jesuss-macbook-pro.local:3000`;
const PRODUCTION_BASE_API_URL = `https://api.buscameaqui.com`;
const BASE_API_URL = ENV_IS_PRODUCTION() ? PRODUCTION_BASE_API_URL : STAGING_BASE_API_URL;

const STAGING_STATIC_ASSETS_BASE_URL = `https://static.buscameaqui.com`;
const PRODUCTION_STATIC_ASSETS_BASE_URL = `https://staging.buscameaqui.com`;

const BASE_STATIC_URL = ENV_IS_PRODUCTION() ? PRODUCTION_STATIC_ASSETS_BASE_URL : STAGING_STATIC_ASSETS_BASE_URL;


export default {
  action(context: any, payload: any) {

    let varOne, varTwo;

    switch(payload.actionType) {
      case types.SET_SELECTED_STATE:
        context.commit("selectedState", payload.value);
        break;

      case types.SET_SELECTED_CATEGORY:
        context.commit("selectedCategory", payload.value);
        break;

      case types.DO_SEARCH:
        context.commit("setResultsLoading", true);

        varOne = `${BASE_API_URL}/listing/search/state/${payload.value.state}/category/${payload.value.category}`

        // console.log('Searching... ', varOne);

        axios.get(varOne,
          { responseType: 'json' })
          .then( (result) => {
            // console.log(result);
            context.commit("setSearchResults", result.data.places);
            context.commit("setResultsLoading", false);
          })
          .catch( (error) => {
            console.error(error)
            context.commit("setResultsLoading", false);
          })
        break;

      case types.FETCH_PLACE_DETAILS:
        context.commit("setPlaceDetailsLoading", true);

        console.log("FETCH_PLACE_DETAILS");

        if ((context.state.fetchedPlaceDetails || { id: -1 } ).id !== payload.value.placeId) {
          console.log("fetching place...");

          axios.get(`${BASE_API_URL}/listing/places/${payload.value.placeId}`,
            { responseType: 'json' })
            .then( (result) => {
              // console.log(result);
              context.commit("setFetchedPlaceDetails", result.data.place);
              context.commit("setResultsLoading", false);
            })
            .catch( (error) => {
              console.error(error)
              context.commit("setFetchedPlaceDetails", null);
              context.commit("setResultsLoading", false);
            })
        } else {
          context.commit("setResultsLoading", false);
        }
        break;

      case types.LOAD_PLACE_DETAILS_FROM_CACHE:
        varOne = context.state.searchResults.items.filter( (placeObj: any) => placeObj.id == payload.value.placeId );
        if (varOne.length > 0) {
          varTwo = varOne[0]

          context.commit("setFetchedPlaceDetails", varTwo)
        } else {
          console.error("This should not happen as of now");
        }

        context.commit("setPlaceDetailsLoading", false);
        break

      case types.FETCH_FAQ:
        if (context.state.fetchedFAQ === null) {
          axios.get(`${BASE_STATIC_URL}/site/getFaq.php`)
            .then( (result) => {
              // console.log(result);
              context.commit("setFAQData", result.data.results);
            })
            .catch( (error) => {
              console.error(error)
            })
        }

        context.commit("setFAQLoading", false);
        break

      case types.SUBMIT_REGISTER_FORM:
        if (context.state.registerFormSubmitting == false) {
          context.commit("registerFormSubmitting", true);

          axios.post(`${BASE_API_URL}/forms/signup`, payload.value)
            .then( (result) => {
              // console.log(result)
              context.commit("registerFormSubmitResult", { success: true, error: null });
            })
            .catch( (error) => {
              context.commit("registerFormSubmitResult", { success: false, error: error });
            })
            .finally( () => {
              context.commit("registerFormSubmitting", false);
            })

        }
        break;

      case types.SUBMIT_SEND_MESSAGE:

        if (context.state.messageFormSubmitting == false) {
          context.commit("messageFormSubmitting", true)

          axios.post(`${BASE_API_URL}/forms/message`, payload.value)
            .then( (result) => {
              // console.log(result);
              context.commit("messageFormSubmitResult", { success: true, error: null })
            })
            .catch ( (error) => {
              context.commit("messageFormSubmitResult", { success: false, error: error })
            })
            .finally(()=> {
              context.commit("messageFormSubmitting", false)
            })
        }

        break;

      default:
        console.error(`Action called with an invalid actionType: ${payload.actionType}`, payload)
        break
    }

  },
}
